import createAxe from '../../middlewares/Axe'

function setOccupationOptions(data) {
  return {
    type: 'SET_OCCUPATION_OPTIONS',
    positions: data.positions,
    industries: data.industries
  }
}

export function fetchOccupationOptions() {
  return async function(dispatch, getState) {
    const axe = createAxe(getState())
    const res = await axe('/3971cc86b21c6924/occupations', {
      method: 'GET',
      headers: { 'Atm-Token': `Bearer ${getState().machine.atm_id}` }
    })
    dispatch(setOccupationOptions(res.data.data))
  }
}
